import { useMessaging } from "@/util/messaging";
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { useNotifications } from "./useNotifications";

export const useNotificationController = defineStore("notification-controller", () => {

	function log(...values: any[]) {
		console.log("[Messaging Controller]", ...values);
	}

	const messaging = useMessaging();

	const useNewSystem = ref('Notification' in window && Notification.permission === 'granted');

	watch(useNewSystem, uns => {
		useNotifications().enabled = !uns;
	}, { immediate: true });

	const supported = computed(() => 'Notification' in window);

	const disabled = ref('Notification' in window && Notification.permission === 'denied');

	async function tryEnableNewSystem() {
		if (!supported.value) {
			log("Not supported");
			return;
		}

		const permission = Notification.permission;
		if (permission === 'granted') {
			messaging.enabled = true;
			useNewSystem.value = true;
			disabled.value = false;
			log("Permission granted");
			return;
		}
		if (permission === 'denied') {
			disabled.value = true;
			useNewSystem.value = false;
			messaging.enabled = false;
			log("Permission denied")
			return;
		}

		log("Requesting permissions");
		const res = await Notification.requestPermission();
		if (res === 'granted') {
			messaging.enabled = true;
			useNewSystem.value = true;
			disabled.value = false;
			log("Permission granted");
		} else {
			messaging.enabled = false;
			disabled.value = true;
			useNewSystem.value = false;
			log("Permission denied")
		}
	}

	if (useNewSystem.value) tryEnableNewSystem();

	return { useNewSystem, supported, tryEnableNewSystem, disabled };
});